import React from 'react';
import { Platform, Image } from 'react-native';
import { Text } from '@tamagui/core';
import { XStack, YStack } from '@tamagui/stacks';
import { BadgeCheck, User } from 'lucide-react-native';
import { COLORS } from '@/constants/colors';
import { ICON_SIZE_LARGE, FONT_SIZE_TITLE, ITEM_GAP } from '../constants';

type ProfileHeaderProps = {
  name: string;
  age: number;
  verified?: boolean;
  isDark?: boolean;
  tagline?: string;
  photoUrl?: string;
};

const ProfileHeader = React.memo<ProfileHeaderProps>(
  ({ name, age, verified, isDark, tagline, photoUrl }) => {
    const textColor = isDark ? COLORS.WHITE : COLORS.ZINC_900;
    const avatarSize = Platform.OS === 'web' ? 56 : 48;

    return (
      <YStack gap={ITEM_GAP}>
        <XStack alignItems="center" gap="$3">
          {/* Name and Age */}
          <YStack flex={1} gap="$1">
            <XStack alignItems="center" gap="$2">
              <Text
                fontSize={Platform.OS === 'web' ? 24 : FONT_SIZE_TITLE}
                fontWeight="700"
                color={textColor}
              >
                {name}, {age}
              </Text>
              {verified ? (
                <BadgeCheck
                  size={ICON_SIZE_LARGE}
                  color={COLORS.WHITE}
                  fill={COLORS.SUCCESS}
                />
              ) : null}
            </XStack>
            {/*{tagline && (
            <Text fontSize={14} color={isDark ? COLORS.WHITE : COLORS.DARK_TEXT} opacity={0.8}>
              {tagline}
            </Text>
          )}*/}
          </YStack>
        </XStack>
      </YStack>
    );
  },
);

ProfileHeader.displayName = 'ProfileHeader';

export default ProfileHeader;
